// src/utils/manufacturing.js
import dayjs from "dayjs";
import Big from "big.js";
import { formatToCompanyTimezone, getYearFromCompanyDate } from "../lib/functions";

const toDecimal = (v) => Number(Big(v || 0).toFixed(13));
export const createManufacturingPayload = (state, authInfo, mf_id) => {
  const {
    voucherNumber,
    footerValues,
    rawCart = [],
    productionCart = [],
    orderId,
    entryDate
  } = state;

  let formatedDate = entryDate ? dayjs(entryDate).toISOString() : null;
  let companydate = formatToCompanyTimezone(formatedDate);
  const vchYear = getYearFromCompanyDate(companydate);

  console.log(rawCart)
  console.log(productionCart)

  return {
    // Production / Finished Items
    vchdate: vchYear,
    itemCart: productionCart.map((p) => ({
      warehouse_id: p.warehouse_id || 0,
      warehouse_name: p.warehouse_name || "",
      item_id: p.item_id,
      item_name: p.product,
      per_unit_id: p.per_unit_id || 0,
      per_unit_symbol: p.per_unit_symbol || "",
      unit_symbol: p.per_unit_symbol || "",
      qty_display: `${p.qty || 0} ${p.unit_symbol || ""}`,
      item_qty: p.qty || 0,
      pd_qty: p.qty || 0,
      retail_qty: p.retail_qty || 0,
      serials: p.serials || [],
      item_rate: toDecimal(p.rate),
      pd_rate: toDecimal(p.rate),
      item_total: toDecimal(p.amount),
      item_percentage: p.item_percentage ?? 100,
      units: p.units || [{ unit_symbol: p.per_unit_symbol, conversion: p.conversion || 1, unit_id: p.per_unit_id }],
      base_unit_name: p.base_unit_name || null,
      unit_name: p.base_unit_name || null,
      conversion: p.conversion || 1,
      is_serial: "no",
      per_conversion: p.per_conversion || 1,
      display_text: `${p.product} - ${p.item_code || ""}`,
      mf_id: mf_id,
      orderId: orderId || 0,
    })),

    // Raw / Material Items
    rawCart: rawCart.map((r) => ({
      warehouse_id: r.warehouse_id || 0,
      warehouse_name: r.warehouse_name || "",
      item_id: r.item_id,
      item_name: r.product,
      per_unit_id: r.per_unit_id || 0,
      unit_name: r.unit_name || "",
      unit_symbol: r.per_unit_symbol || "",
      per_unit_symbol: r.per_unit_symbol || "",
      qty_display: `${r.qty || 0} ${r.unit_symbol || ""}`,
      raw_item_qty: toDecimal(r.qty),
      raw_item_rate: toDecimal(r.rate),
      raw_qty: toDecimal(r.raw_qty || r.qty),
      raw_rate: toDecimal(r.raw_rate || r.rate),
      raw_retail_qty: toDecimal(r.raw_retail_qty),
      raw_item_total: toDecimal(r.amount),
      serials: [],
      units: r.units || [],
      base_unit_name: r.base_unit_name || null,
      per_conversion: r.per_conversion || 1,
      raw_conversion: r.per_conversion || 1,
      display_text: `${r.product} - ${r.item_code || ""}`,
    })),

    // Master data for the journal
    masterData: {
      mf_id: mf_id || undefined,
      mf_voucher_no: voucherNumber || "",
      narration: footerValues?.description || "",
      labour_cost: toDecimal(footerValues?.labourCost),
      others_cost: toDecimal(footerValues?.otherCost),
      total_cost: toDecimal(footerValues?.totalCost),
      is_serial: "no",
      ...( (!mf_id) && {created_by: authInfo?.userInfo?.full_name || "" ,
      }),
      created_date: formatedDate || null,
    },
  };
};
